module.exports = __webpack_public_path__ + "static/media/image_3.584f0552.png";